











































































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import IArrow from '@/components/icons/IArrow.vue'
import ContactsShard from '@/components/lfs/NewShardList/SelectedShard/ContactsShard.vue'
import DataSources from '@/components/lfs/NewShardList/SelectedShard/DataSources.vue'
import MediaAttachments from '@/components/lfs/NewShardList/SelectedShard/MediaAttachments.vue'
import SurveysShard from '@/components/lfs/NewShardList/SelectedShard/SurveysShard.vue'
import draggable from 'vuedraggable'
import IUpload from '@/components/icons/IExport.vue'
import IUploadFile from '@/components/icons/IUpload.vue'
import IArchive from '@/components/icons/IArchive.vue'
import BtnDefault from '@/components/UI/BtnDefault.vue';

const newshards = namespace('newshards')
const forms = namespace('forms')
const dialog = namespace('dialog')

@Component({
  components: {
    'i-arrow': IArrow,
    ContactsShard,
    DataSources,
    MediaAttachments,
    SurveysShard,
    'i-upload': IUpload,
    'i-archive': IArchive,
    'i-upload-file': IUploadFile,
    BtnDefault,
   }
})

export default class SelectedShard extends Vue {
  @newshards.State('loadShardStatus') protected loadShardStatus:any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @dialog.Mutation('SetTitleDialog') protected SetTitleDialog: any
  @dialog.Mutation('SetFormSDialog') protected SetFormSDialog: any

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @forms.Mutation('setOptions') protected setOptions: any

  @Prop({type: [Boolean], default: false}) protected isSelectedShard!: boolean
  @Prop({type: [Object], default: {}}) protected shard!: any
  @Prop({type: Boolean, default: false}) protected disabledShard!: boolean

  scroll:boolean = false
  panel:any = [0, 1]
  isStopScroll:boolean = false

  created() {
    window.addEventListener('scroll', this.changeScroll);
  }

  destroyed() {
    window.removeEventListener('scroll', this.changeScroll)
  }

  changeScroll() {
    if(window.pageYOffset < 170) {
      (document.querySelector('.lfs-selected-shard')  as HTMLElement).scrollTop = 0
      this.scroll = false
    } else {
      this.scroll = true
    }
  }

  exportAll() {
    this.setOptions()
    this.SetTitleDialog(this.$t('newShardList.export.titleFirst'))
    this.SetFormSDialog('ExportAllForm')
    this.SetFullDialogShow(true)
  }

  exportOne() {
    let options = {
      id: this.shard.id
    }
    this.setOptions(options)
    this.SetTitleDialog(this.$t('newShardList.export.title'))
    this.SetFormSDialog('ExportOneForm')
    this.SetFullDialogShow(true)
  }

  changeStopScroll(isStop:boolean) {
    this.isStopScroll = isStop
  }

  isArchiveFun(payload:any){
    this.$emit('isArhive',payload)
  }

}
